import styled, { css } from 'styled-components';
import Image from 'next/image';

import { devices, applyBoxShadowSm, screenBreakpoints } from '@/UI/Styles';
import { keyFramesSlideBottom, slideBottom } from '../../utils';
import { Paragraph } from '@/UI/Atoms/Paragraph';

interface LocationsContainer {
  hasDescription?: boolean;
  hasSearchBar?: boolean;
  isIframe?: boolean;
}

export const SearchBarContainer = styled.div<{ scrolled?: boolean; isRef?: boolean }>`
  background-color: ${({ theme }) => theme.migrateColors('background.primary', 'white')};
  width: 100%;
  display: ${({ isRef }) => (isRef ? 'flex' : 'none')};
  border-radius: ${({ theme }) => theme.borderRadius.sm};

  @media ${`(max-width: ${screenBreakpoints.sm})`} {
    ${({ scrolled, isRef }) =>
      scrolled &&
      !isRef &&
      css`
        display: flex;
        ${applyBoxShadowSm};
        padding-bottom: 0px;
        position: fixed;
        top: -100px;
        left: 0;
        padding: 17px 15px 19px 15px;
        z-index: 5;
        ${slideBottom}
        ${keyFramesSlideBottom}
      `}
  }
`;

export const Container = styled.div<LocationsContainer>`
  color: ${({ theme }) => theme.migrateColors('text.subtle', 'gray80')};

  & .sticky + .cardLocalContainer {
    padding-top: 70px;
  }

  .mobileDescription {
    display: block;
  }
`;

export const CompanyDescriptionWrapper = styled.div`
  width: 100%;
  padding-right: 20px;
  text-align: left;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const CardsAndMapWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: auto;

  .sectionTitle {
    font-size: 24px;
    font-weight: 500;
    color: ${({ theme }) => theme.migrateColors('text.default', 'gray')};
    margin-bottom: 16px;
  }

  @media ${devices['no-mobile']} {
    margin: 16px auto;
  }

  @media ${devices.XLarge} {
    max-width: 1080px;
  }
`;

export const MapWrapper = styled.div`
  margin-top: 40px;
  display: none;
  button {
    margin-top: 16px;
  }
  @media ${devices.XLarge} {
    display: flex;
    flex-direction: column;
  }
`;

export const HeaderScrollBox = styled.div`
  min-height: 48px;
  margin-bottom: 24px;
`;

export const CardLocalWrapper = styled.div`
  padding-bottom: 15px;
  width: 100%;

  @media ${devices.XLarge} {
    min-height: 650px;
    overflow-x: hidden;
    position: relative;
  }
`;

export const CardsWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  row-gap: ${({ theme }) => theme.spacing.md};

  .locationsHeadline {
    margin-bottom: 16px;
    text-align: left;
    width: 100%;
  }

  @media ${devices['no-mobile']} {
    grid-template-columns: 1fr 1fr;
    row-gap: 24px;
    column-gap: ${({ theme }) => theme.spacing.lg};
  }
`;

export const NoResultContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  margin: 6rem 0;

  .noResultTitle {
    font-size: 24px;
    margin-top: ${({ theme }) => theme.spacing.md};
    font-weight: 500;
  }

  .noResultSubtitle {
    font-size: 18px;
    margin-top: ${({ theme }) => theme.spacing.md};
    font-weight: 700;
    text-align: center;
  }

  .seeAllLocationsButton {
    margin-top: ${({ theme }) => theme.spacing.md};
    color: ${({ theme }) => theme.brandTheme.brand50};
    text-decoration: underline;
    font-size: 18px;
  }

  .emptyResultsIcon {
    path:nth-child(1),
    path:nth-child(5) {
      fill: ${({ theme }) => theme.brandTheme.brand50};
    }
    path:nth-child(4),
    path:nth-child(6),
    path:nth-child(7),
    path:nth-child(8) {
      fill: ${({ theme }) => theme.brandTheme.brand100};
    }
    path:nth-child(9) {
      stroke: ${({ theme }) => theme.brandTheme.brand50};
    }
    path:nth-child(10),
    path:nth-child(12) {
      fill: ${({ theme }) => theme.brandTheme.brand50};
      stroke: ${({ theme }) => theme.brandTheme.brand50};
    }
  }
`;
